import { useEffect, useState } from "react";

/**
 * Kipkruiden branding assets (logos, favicon).
 * Stored in localStorage as data-URIs — NON-SENSITIVE UI preferences only.
 * Contains no user credentials, tokens, or personal data.
 */
const DEFAULT_LOGO = "/brand/kipkruiden-logo.png";
// Zelfde logo zonder transparante rand, voor de grote weergave op het dashboard.
const TRIMMED_LOGO = "/brand/kipkruiden-logo-trim.png";
const DEFAULT_MARK = "/brand/kipkruiden-mark.png";

/** Read a custom logo from localStorage (uploaded via Instellingen > Huisstijl). */
function readCustom(key) {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(key);
}

/** Listen for updates to the branding in localStorage. */
function useBrandingUpdate() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const onUpdate = () => setTick((t) => t + 1);
    window.addEventListener("kipkruiden-branding-update", onUpdate);
    window.addEventListener("storage", onUpdate);
    return () => {
      window.removeEventListener("kipkruiden-branding-update", onUpdate);
      window.removeEventListener("storage", onUpdate);
    };
  }, []);
  return tick;
}

export function BrandLogo({ variant = "full", className, height, alt = "Kipkruiden.nl", trimmed = false, ...props }) {
  useBrandingUpdate();
  const key = variant === "mark" ? "kipkruiden-brand-mark" : "kipkruiden-brand-logo";
  const fallback = variant === "mark" ? DEFAULT_MARK : (trimmed ? TRIMMED_LOGO : DEFAULT_LOGO);
  const src = readCustom(key) || fallback;
  // If a fixed pixel height is given, use inline style; otherwise let Tailwind classes control size.
  const style = height ? { height: `${height}px`, width: "auto" } : undefined;
  return (
    <img src={src} alt={alt} className={className} style={style}
      loading="lazy" {...props} />
  );
}
